"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 *
 * @ignore
 */

function containsValidProofStatement(searchText) {
  var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (!name) {
    return false;
  }

  searchText = searchText.toLowerCase();

  if (name.split('.').length < 2) {
    throw new Error('Please provide the fully qualified Blockstack name.');
  }

  var username = null; // support legacy Blockstack ID proofs

  if (name.endsWith('.id')) {
    username = name.split('.id')[0];
  }

  var verificationStyles = username != null ? ["verifying myself: my bitcoin username is +".concat(username), "verifying myself: my bitcoin username is ".concat(username), "verifying myself: my openname is ".concat(username), "verifying that +".concat(username, " is my bitcoin username"), "verifying that ".concat(username, " is my bitcoin username"), "verifying that ".concat(username, " is my openname"), "verifying that +".concat(username, " is my openname"), "verifying i am +".concat(username, " on my passcard"), "verifying that +".concat(username, " is my blockchain id"), "verifying that \"".concat(name, "\" is my blockstack id"), "verifying that ".concat(name, " is my blockstack id"), "verifying that &quot;".concat(name, "&quot; is my blockstack id")] : ["verifying that \"".concat(name, "\" is my blockstack id"), "verifying that ".concat(name, " is my blockstack id"), "verifying that &quot;".concat(name, "&quot; is my blockstack id")];

  for (var i = 0; i < verificationStyles.length; i++) {
    var verificationStyle = verificationStyles[i];

    if (searchText.includes(verificationStyle)) {
      return true;
    }
  }

  if (username != null && searchText.includes('verifymyonename') && searchText.includes("+".concat(username))) {
    return true;
  }

  return false;
}

exports.containsValidProofStatement = containsValidProofStatement;
/**
 *
 * @ignore
 */

function containsValidAddressProofStatement(proofStatement, address) {
  proofStatement = proofStatement.split(address)[0].toLowerCase() + address;
  var verificationStyles = ["verifying my blockstack id is secured with the address ".concat(address)];

  for (var i = 0; i < verificationStyles.length; i++) {
    var verificationStyle = verificationStyles[i];

    if (proofStatement.includes(verificationStyle)) {
      return true;
    }
  }

  return false;
}

exports.containsValidAddressProofStatement = containsValidAddressProofStatement;